import { useContext, useEffect, useState } from "react";
import { Backdrop, Box, CircularProgress, Stack } from '@mui/material';
import { BranchProductRead, BranchRead } from "../../../../global/API";
import { ToolContext } from "../../../../../../core/context/ToolContext";
import { Thead } from "./Thead";
import { Tbody } from "./Tbody";

import { FeatureIdState } from "../../../../toolUsage/global/GlobalFcn";
import { CreateFeatureLogs } from "../../../../global/API";

export const Index = () => {
    const { tool_state, setup_state, report_state, global_component_state } = useContext(ToolContext)
    const { __SESSION } = tool_state
    const { branchData } = setup_state
    const { salesProductList ,form, comProductIds, branchProductData, generateForm, salesProductData } = report_state
    const { snackBarLoader } = global_component_state

    const [open, setOpen] = useState(false)

    const tool_id =  process.env.REACT_APP_TID_BIZ;

    const inputChangeHandler = async(e, val, key) => {
        let name
        let value
        if (key === 'branch_id' || key === 'product_id' ) {
            name = key;
            value = (val === null ? 0 : (key === 'branch_id' ? val.company_branch_id : val.id) );
            
            if (key === 'branch_id') {
                await __getBranchProduct(value)
            }else{
                if (val) {
                    await __getProduct(val)
                }
            }
        }else{
            name = e.target.name
            value = e.target.value
        }   
        if (key==='branch_id') {
            form.set({...form.data, [name]:value, product_id:key==='branch_id'? 0 : form.data.product_id})
        }else{
            form.set({...form.data, [name]:value})
        }
        salesProductData.set([])
        generateForm.set((prev) => ({...prev, infiniteLoad:false, offset:0}))
    }

    const __getProduct = async(val) => {
        if (val.id !== 0 && form.data.branch_id === 0) {
            let qsp = {
                sub_category_id:val.sub_category_id,
                product_id:val.company_product_id,
                filter:'all-products'
            }
            let product_id = []
            let res = await BranchProductRead(qsp)
            if (res) {
                res.filter((v) => product_id.push(v.id))
                comProductIds.set(product_id)
            }
        }
    }

    const __getBranchProduct = async(comp_branch_id) => {
        let qsp = {
            show:2,
            company_id:__SESSION.data.uaccess[0].company_id,
            branch_id:comp_branch_id,
            filter:'reports'
        }
        let res = await BranchProductRead(qsp)
        const visibleProducts = res.filter(item => +item.visible !== 0);
        if (res) branchProductData.set([{id:0, sub_cat_name:'All', product_name:'', code:'000', active:1, alias: null}, ...visibleProducts])
    }

    const __init = async() => {
        let res = await BranchRead(__SESSION.data.uaccess[0].company_id, 'active')
        if (res) branchData.set([{id:0, company_branch_id:0,  name:'All', code:'000', active:1,}, ...res])
        await __getBranchProduct(0)
    }

    const SendFeatureLogs = async()=>{
        let body = {
            aid: __SESSION.data.ainfo.aid,
            path: `${FeatureIdState('reports')}->2`,
            feature_id: 2,
            feature_name: "branch-product-sales-report",
            tid: tool_id,
            company_id: __SESSION.data.uaccess[0].company_id,
            action: 2
        }
        await CreateFeatureLogs(body)
    }

    useEffect(() => {
        __init()
        SendFeatureLogs()
        //eslint-disable-next-line
    }, [])

    return (
        <Box sx={{height: "100%"}}>
            <Thead inputChangeHandler={inputChangeHandler} form={form.data} branchData={branchData} branchProductData={branchProductData.data} snackBarLoader={snackBarLoader} open={open} setOpen={setOpen}/>
            <Tbody salesProductList={salesProductList.data} generateForm={generateForm.data}/>
            <Backdrop open={generateForm.data.infiniteLoad} sx={{zIndex: '1300'}}>
                <Box height="150px" width="100%" display="flex" alignItems="center" justifyContent="center">
                    <Box height="100%" width="270px" borderRadius="12px" display="flex" flexDirection="column" alignItems="center" justifyContent="center" gap={3}>
                        <Stack sx={{ color: 'grey.300' }} spacing={2} direction="row">
                            <CircularProgress color="inherit"  />
                        </Stack>
                        <Box color="#fff">Fetching data ...</Box>
                    </Box>
                </Box>
            </Backdrop>
        </Box>
    )
}